import { Dispatch, FC, SetStateAction } from "react";
import { Modal } from "@app/shared/Modals";
import { DistanceMeasurementRadioGroup } from "@app/shared/terminations/DistanceMeasurementRadioGroup";

interface ProcessAllChangesConfirmationModalProps {
  hasUnprocessedTerminations: boolean;
  isModalOpen: boolean;
  isSkipSelected: boolean;
  isZipProject: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
  setShouldSkip: Dispatch<SetStateAction<boolean>>;
  handleConfirm: () => void;
}

const ProcessAllChangesConfirmationModal: FC<ProcessAllChangesConfirmationModalProps> = (props: ProcessAllChangesConfirmationModalProps) => {
  const closeModal = () => {
    props.setIsModalOpen(false);
  };

  return (
    <Modal
      closeModal={closeModal}
      content={{
        body: (
          <div className="ps-3 pe-3 mb-3">
            <p className="mb-0">Clicking Confirm will process all unprocessed action rules for this project.</p>
            {props.hasUnprocessedTerminations ? (
              <div className="mt-3">
                <DistanceMeasurementRadioGroup
                  name="provider-actions-drawer-skip-time-distance-recalc"
                  title="Termed Avg. & Max. Recalculation"
                  isZipProject={props.isZipProject}
                  shouldSkip={props.isSkipSelected}
                  setShouldSkip={props.setShouldSkip}
                  computeTestId="provider-actions-drawer__compute-time-distance"
                  skipTestId="provider-actions-drawer__skip-time-distance"
                  tooltipBodyClassName="qes-distance-measurement__tooltip"
                  containerClassName="mb-2"
                  showCallout={props.isSkipSelected}
                />
              </div>
            ) : null}
          </div>
        ),
        cancelButtonText: "Cancel",
        confirmButtonAction: props.handleConfirm,
        confirmButtonText: "Confirm",
        title: "Process All Changes",
      }}
      isVisible={props.isModalOpen}
      hideBodyScroll={true}
    />
  );
};

export default ProcessAllChangesConfirmationModal;
